/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Registry_CommercialInputs */

const es_ab_registry_commercial = /** @type {(inputs: Ab_Registry_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comercial`)
};

const gl_ab_registry_commercial = /** @type {(inputs: Ab_Registry_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comercial`)
};

const en_ab_registry_commercial = /** @type {(inputs: Ab_Registry_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`commercial`)
};

/**
* | output |
* | --- |
* | "commercial" |
*
* @param {Ab_Registry_CommercialInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_registry_commercial = /** @type {((inputs?: Ab_Registry_CommercialInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Registry_CommercialInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_registry_commercial(inputs)
	if (locale === "en") return en_ab_registry_commercial(inputs)
	return es_ab_registry_commercial(inputs)
});